import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import styled from 'styled-components';
var Spinner = require('react-spinkit');
import DatePicker from 'react-datepicker';
import moment     from 'moment';

class RenewalAnalysis extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    const search = props.location.search; // returns the URL query String
    const params = new URLSearchParams(search);
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      selected_tab:0,
      data:[],
      headers: [],
      renewed:[],
      search:'',
      loading: false,
      isVisible:false,
      excel_data:[],
      selected_date:'2200-01-01',
      game_types: [
        {name: 'F-Improve', id:2 },
        {name: 'F-Play', id:1 },
        {name: 'F-Academy', id:8 },
        {name: 'F-Rental', id:12 },
        {name: 'F-Tour', id:13 },
        {name: 'B-Improve', id:4 },
        {name: 'B-Play', id:3 },
        {name: 'B-Rental', id:18 },
        {name: 'B-Academy', id:10 },
        {name: 'B-Tour', id:14 },    
      ] ,
      selected_game:2
    };
    this.handleDate = this.handleDate.bind(this);
  }

  componentDidMount() {
    this.locationChanged();
    // this.getRenewalSummary();
    // this.getRetentionSummar
   
  }

  locationChanged() {
    this.setState({venue:this.props.statsTable.revenue_per_month.requested_venue_id,loading:false}, () => {
      if(this.state.selected_tab == 0){
        this.getRenewalSummary()
      }
      else{
        this.getRetentionSummary()
      }
      
      
    })
  }
  datepickerVisible(isVisible){
    if(isVisible){
      this.setState({selected_date:moment().format("YYYY-MM-DD"),isVisible:true},()=>{
        this.getRenewalSummary()
      })
    }
    else{
      this.setState({selected_date:"2200-01-01",isVisible:false},()=>{
        this.getRenewalSummary()
      })
    }
  }
  getRenewalSummary(){
    this.setState({loading:false})
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=1144&venue_id=${this.state.venue}&date=${this.state.selected_date}`;
    const options = {...defaultOptions};

      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
              this.setState({data:data.data,headers:data.headers,loading:true})
         }).catch(error => error);
  }

  getRetentionSummary(){
    this.setState({loader:false})
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=7564&venue_id=${this.state.venue}&game_type_id=${this.state.selected_game}&date=${this.state.selected_date}`;
    const options = {...defaultOptions};

      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
              this.setState({r_data:data.data,r_headers:data.headers,loader:true})
         }).catch(error => error);
  }
   handleDate(date){
    var dd = date.format("YYYY-MM-DD")
      this.setState({selected_date: dd},()=>{
        this.getRenewalSummary()
      });

      console.log("date",dd)
    }
 renderRenewlSummary(){
  var renewed = [] 
    var tab_index_expired = []
    var tab_index_renewed = []
    var tab_index_percentage=[]
    if(this.state.headers.length > 0){
      
      for (var i = 0; i < this.state.headers.length; i++) {
        if(this.state.headers[i].indexOf("Renewed") >= 0){
          tab_index_renewed.push(i);
        }
         if(this.state.headers[i].indexOf("Expired") >= 0){
          tab_index_expired.push(i);
        }
          if(this.state.headers[i].indexOf("Percentage") >= 0){
          tab_index_percentage.push(i);
        }
      }
    }
    return(
      <div>
           
        {this.state.loading ?
          <div>
           <div className="table-responsive" style={{borderRadius:'15px',display:'contents'}}>
           { this.state.data && this.state.data.length > 0 &&
              this.state.data.map((data)=>(
              <table className="table table-hover">
                <thead>
                <div style={{top: "0",left: "0",right: "0",zIndex: "None"}}> {data[0]}</div>
                  <tr>
                    <Th></Th>
                    <Th scope="col">Total</Th>
                    <Th scope="col">Football Academy</Th>
                    <Th scope="col">Badminton Academy</Th>
                    <Th scope="col">Swimming Academy</Th>
                    <Th scope="col">Football Adults</Th>
                    <Th scope="col">Badminton Adults</Th>
                    <Th scope="col">Swimming Adults</Th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <Th scope="row">Renewal</Th>
                    {data.map((item,index)=>(
                      tab_index_renewed.includes(index) &&
                      <td style={{paddingRight:'25px'}} dangerouslySetInnerHTML={{__html:item}}></td>
                      ))
                    }
                  </tr>  
                  <tr>
                    <Th scope="row">Expired</Th>
                    {data.map((item,index)=>(
                      tab_index_expired.includes(index) &&
                      <td dangerouslySetInnerHTML={{__html:item}}></td>
                      ))
                    }
                  </tr>  
                  <tr>
                    <Th scope="row">Renewal %</Th>
                    {data.map((item,index)=>(
                      tab_index_percentage.includes(index) &&
                      <td style={{fontWeight:'950',fontSize:'18px'}} dangerouslySetInnerHTML={{__html:item}}></td>
                      ))
                    }
                  </tr>
                </tbody>
              </table>
              ))
            }
            </div>
          </div>
        :
          <div style={{height:500}}>
            <div style={{  position: 'absolute',top: '50%',left: '50%',width: '50%',height: '100%'}}> <Spinner size="50" name="ball-spin-fade-loader" color="#115691" /></div>
          </div>
        } 
      </div>
    )
 }
 
 renderRetentionSummary(){

  return(
                <div>
            <div className='col-md-12' style={{marginBottom:'1%',display:'flex',flexDirection:'row'}}>          
              {this.state.game_types.map((game_type)=>(
                <button className='btn btn-primary' style={{border:this.state.selected_game == game_type.id && '2px solid #011047',fontWeight:'900',width:'9%'}}
                    onClick={()=>this.setState({selected_game:game_type.id},()=>{
                      this.getRetentionSummary()
                    })}>{game_type.name}</button>
              ))
              }
            </div>
          {this.state.loader ?
            <div className="table-responsive" style={{borderRadius:'15px',display:'contents'}}>
              <table className="table table-hover" style ={{width:'100%',borderRadius:'15px',boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.20)'}}>
                <tr>
                  {this.state.r_headers.map((item)=>(
                    <th style={{textAlign:'center',height:'40px',backgroundColor:'#115691',color:'white'}}> {item} </th>
                    ))
                  }
                </tr>
                <tbody>
                  { this.state.r_data && this.state.r_data.length > 0 ?
                    this.state.r_data.map((data)=>(
                      <tr style={{backgroundColor:'white'}}>
                        { data.map((each,key)=>
                          <td style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html:each}}></td>
                          )
                        }
                      </tr>

                    ))
                  :
                    <tr></tr>}
                </tbody>
                </table>
            </div>
            :
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '60%',left: '50%',width: '50%',height: '100%'}}> <Spinner size="50" name="ball-spin-fade-loader" color="#115691" /></div>
            </div>
            } 
          
          </div> 
    )
 }
  render() {
    if(this.state.venue != this.props.statsTable.revenue_per_month.requested_venue_id){
      this.locationChanged()
    }  


    return(
      <div>

        <div className="breadcrumps" style={{marginBottom:'1%'}}>
            <a href={'/#/dashboard/ActiveCustomer'} >
              <span>Dashboard</span>
            </a>
            <a>
            {this.state.selected_tab == 0 ?
              <span>Renewal Analysis</span>
              :this.state.selected_tab == 1 ?
              <span>Customer Retentions</span>
              : null
            }
            </a>
        </div>
        <div className="col-md-10" >
        {this.state.isVisible ?
        <div>
        <button style={{marginTop: "13px"}} onClick={()=>this.datepickerVisible(false)}>
          <span>Hide Calender</span>
        </button>
        <div className="col-md-2" style={{padding:'1%'}}> 
                <DatePicker selected={moment(this.state.selected_date)} onChange={date =>this.handleDate(date)} />
          </div>
        </div>
        :
        <button onClick={()=>this.datepickerVisible(true)}>
          <span>Show Calender</span>
        </button>
        }
        </div>

        
        <TabHeader className='col-md-12' style={{marginBottom:'1%'}}>
          <Tabs onClick = {()=>this.setState({selected_tab: 0},()=>{
            this.getRenewalSummary()
          })} style={{color:this.state.selected_tab === 0 && 'white',backgroundColor:this.state.selected_tab === 0 && 'green'}}> Renewal Analysis </Tabs>
          <Tabs onClick = {()=>this.setState({selected_tab: 1},()=>{
            this.getRetentionSummary()
          })} style={{color:this.state.selected_tab === 1 && 'white',backgroundColor:this.state.selected_tab === 1 && 'green'}}> Customer Retentions </Tabs>
        </TabHeader>
        
        
        { this.state.selected_tab == 0 &&
           this.renderRenewlSummary()
          }
          {this.state.selected_tab == 1 &&
            this.renderRetentionSummary()
          }
   
      </div>
      )
  }
}

export default RenewalAnalysis;


const TabHeader = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 20px;
  margin-top:10px;
`


const Tabs = styled.div`
  color: black ;
  background-color:beige;
  transition:0.5s;
  border: 2px solid green;
  padding: 7px;
  font-weight: 700;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
`
const Th =styled.th`
  width : 9em;
`



// WEBPACK FOOTER //
// ./src/app/views/centerportal/renewalAnalysis/RenewalAnalysis.js